// AI-CONTEXT: See docs/features/default-housevisit-reminders.md
// De automatische herinnering bij een huisbezoek, zoals de organisatie hem
// heeft ingesteld (Instellingen → Ondersteuning → 'Standaard herinnering bij
// huisbezoek'): aan of uit, per e-mail en/of SMS, en hoeveel dagen van tevoren.
// Eén lezing van CompagnyMeta, zodat de instellingen, de twee inplanpaden
// (afspraak bevestigen op de huishoudenpagina, slepen in de agenda) en de
// handleiding dezelfde regels kennen.

/** De keuzes in de instellingen, in deze volgorde. */
const REMINDER_CHANNELS = [
    { value: 'email', label: 'E-mail' },
    { value: 'sms', label: 'SMS' },
    { value: 'both', label: 'E-mail en SMS' },
]

/** Verder vooruit dan twee weken is geen herinnering meer. */
const MAX_DAYS_BEFORE = 14

/** Zonder keuze: één dag van tevoren, zoals het altijd was. */
const DEFAULT_DAYS_BEFORE = 1

/**
 * Aan/uit-vlaggen komen in twee vormen voor: ToggleButton schrijft tekst,
 * andere schrijvers booleans. Beide tellen.
 * @param {*} value
 * @returns {boolean}
 */
const aan = (value) => value === true || value === 'true'

/**
 * @typedef {object} DefaultReminderPlan
 * @property {boolean} enabled - Of er bij het inplannen automatisch een herinnering komt
 * @property {Array<'email'|'sms'>} channels - Per kanaal één herinnering; nooit leeg
 * @property {number} daysBefore - Hoeveel dagen vóór het bezoek, 0 = de ochtend van het bezoek
 */

/**
 * @param {object} [meta] - Het CompagnyMeta-document (of de relevante velden)
 * @param {*} [meta.DefaultHouseVisitReminder] - De hoofdschakelaar
 * @param {*} [meta.DefaultHouseVisitReminderChannel] - 'email' | 'sms' | 'both'
 * @param {*} [meta.DefaultHouseVisitReminderDays] - Dagen van tevoren
 * @param {*} [meta.SmsRemindersEnabled] - Of SMS voor deze organisatie aanstaat (betaald, apart aan te zetten)
 * @returns {DefaultReminderPlan}
 */
const resolveDefaultReminderPlan = (meta) => {
    const m = meta || {}

    // SMS kan alleen als de organisatie SMS-herinneringen aan heeft; is dat
    // niet (meer) zo, dan per e-mail — liever een herinnering dan stil geen.
    const smsKan = aan(m.SmsRemindersEnabled)
    const gekozen = REMINDER_CHANNELS.some((c) => c.value === m.DefaultHouseVisitReminderChannel)
        ? m.DefaultHouseVisitReminderChannel
        : 'email'
    const channels = !smsKan ? ['email']
        : gekozen === 'sms' ? ['sms']
            : gekozen === 'both' ? ['email', 'sms']
                : ['email']

    // `Number('')` is 0, en 0 betekent hier 'de ochtend van het bezoek' — een
    // leeg veld mag dus niet stil in 0 veranderen; dat is 'niets gekozen'.
    const ruw = m.DefaultHouseVisitReminderDays
    const dagen = ruw === '' || ruw === null || ruw === undefined ? NaN : Number(ruw)
    const daysBefore = Number.isInteger(dagen) && dagen >= 0 && dagen <= MAX_DAYS_BEFORE
        ? dagen
        : DEFAULT_DAYS_BEFORE

    return {
        enabled: aan(m.DefaultHouseVisitReminder),
        channels,
        daysBefore,
    }
}

export { REMINDER_CHANNELS, MAX_DAYS_BEFORE, DEFAULT_DAYS_BEFORE }
export default resolveDefaultReminderPlan
